import React from "react";
import TaskResponseSummary from "./TaskResponseSummary";

// Read-only view of an inspection item: its verdict as a pill, the standard
// it was judged against, and the auditor's note.

export function VerdictPill({ value, size = "sm" }) {
  const cls =
    value === true
      ? "bg-emerald-50 text-emerald-700 border-emerald-200"
      : value === false
      ? "bg-rose-50 text-rose-700 border-rose-200"
      : "bg-slate-50 text-slate-500 border-slate-200";
  const label = value === true ? "Pass" : value === false ? "Fail" : "Not answered";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-bold whitespace-nowrap ${cls} ${
        size === "xs" ? "text-[10px] px-1.5 py-px" : "text-[11px] px-2 py-0.5"
      }`}
    >
      {label}
    </span>
  );
}

function TaskPassFailCompleted(props) {
  return <TaskResponseSummary {...props} status={<VerdictPill value={props.subtask.value_boolean} />} />;
}

export default TaskPassFailCompleted;
